import styled, { keyframes } from 'styled-components';

import { device } from '@/styles/helpers';

export const ScPromotions = styled.div`
  & > div:nth-child(odd) {
    background-color: ${({ theme }) => theme.whiteColor};
  }
`;

export const ScPromotionsArea = styled.div`
  color: ${({ theme }) => theme.mainColor};
  & > div {
    & > div:not(:last-child) {
      margin-bottom: 16px;
    }
  }
  padding: 72px 0;
  display: flex;
  flex-direction: row;
  h2 {
    margin-bottom: 40px;
  }
  @media (${device.mobile}) {
    padding: 40px 0;
    h2 {
      margin-bottom: 24px;
    }
  }
  @media (${device.mobileS}) {
    padding: 24px 0;
    h2 {
      margin-bottom: 16px;
    }
  }
`;

export const ScPromotionsCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

export interface ScPromotionsCardLeftProps {
  bg?: string;
}

export const ScAnimatedParticlesContainer = styled.div`
  position: absolute;

  top: 0;
  left: 0;

  z-index: 10;

  width: 100%;
  height: 100%;
`;

export const particleOpacityAnimation = keyframes`
  0%, 25%, 75%, 100% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.2;
    transform: scale(0);
  }
`;

export const ScAnimatedParticlesImage = styled.img<{
  positionX: number;
  positionY: number;
  delay: number;
}>`
  max-width: 60px;
  width: 100%;

  filter: blur(0.5px);

  position: absolute;

  top: ${({ positionY }) => positionY}%;
  left: ${({ positionX }) => positionX}%;

  animation: infinite ease-in-out ${({ delay }) => delay}s
    ${particleOpacityAnimation};

  @media (${device.mobile}) {
    max-width: 40px;
  }
`;

export const ScPromotionsCardLeft = styled.div`
  position: relative;
  width: 100%;
  height: 0px;
  padding-top: 56%;

  & > .promo-image {
    border-radius: 16px 16px 0px 0px;
  }
`;

export const ScPromotionsCardRight = styled.div`
  padding: 32px;
  color: ${({ theme }) => theme.blackColor};
  background-color: ${({ theme }) => theme.whiteColor};
  display: flex;
  flex-direction: column;
  flex: 1;
  border-radius: 0 0 16px 16px;

  & > div {
    & > header {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      align-items: center;
      margin-bottom: 8px;

      & > h2 {
        font-size: 20px;
        line-height: 1.4;
        color: ${({ theme }) => theme.blackColor};
        text-transform: uppercase;
      }

      @media (${device.mobile}) {
        margin-bottom: 8px;

        & > h2 {
          font-size: 18px;
        }
      }
    }

    .description {
      & > p {
        font-size: 16px;
        @media (${device.mobile}) {
          font-size: 14px;
        }
      }

      & > p,
      & > ul {
        line-height: 1.5;
        color: ${({ theme }) => theme.grayColor};
        font-weight: normal;
        margin-bottom: 16px;
      }

      & > ul {
        margin-left: 1em;
      }

      & > p:not(:last-child),
      & > ul:not(:last-child) {
        margin-bottom: 16px;
        @media (${device.mobile}) {
          margin-bottom: 8px;
        }
      }
    }
  }

  & > .buttons {
    display: grid;
    grid-template-columns: 180px max-content;
    align-items: center;
    margin-top: auto;
    row-gap: 16px;
    @media (${device.mobile}) {
      grid-template-columns: 1fr;
    }
  }
`;

export const ScCardRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  position: relative;

  @media (${device.desktop}) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (${device.mobile}) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const ScNotFoundPromotions = styled.div<{
  deskBackground: string;
  mobBackground: string;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 35px;
  border-radius: 8px;
  background-image: ${({ deskBackground }) => `url(${deskBackground})`};
  background-color: ${({ theme }) => theme.grayLightColor};
  background-size: cover;
  background-repeat: no-repeat;
  background-position-x: center;
  @media (${device.mobile}) {
    padding: 74px 35px;
    background-image: ${({ mobBackground }) => `url(${mobBackground})`};
  }
  span {
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    max-width: 512px;
  }
`;

export const ScAllOffers = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;
